module.exports = __webpack_public_path__ + "static/media/gb.fe60f831.svg";